<template>
  <div>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="title primary--text">{{ $t('decrease.section') }}</div>
      <v-spacer/>
      <v-btn
        rounded
        small
        depressed
        color="primary"
        :disabled="!table.items.length"
        @click="update">
        {{ $t('decrease.create') }}
      </v-btn>
    </div>

    <v-flex
      v-if="idArea"
      xs12>
      <v-card>
        <v-form ref="decreasesForm">
          <v-data-table
            hide-default-footer
            :headers="table.headers"
            :items="table.items"
            no-data-text=""
            class="fixed-header">
            <template v-slot:footer>
              <v-btn
                tile
                text
                color="primary"
                width="100%"
                @click="add">
                <v-icon>
                  mdi-plus
                </v-icon>
                {{ $t('orders.buttons.addProduct') }}
              </v-btn>
            </template>
            <template
              v-slot:item.quantity="{ item }">
              <v-text-field
                type="number"
                placeholder="¿Cuánta merma se generó de este producto?"
                :suffix="((item.choice || {}).displayUnit || {}).name || ''"
                :rules="rules.quantity"
                v-model.number="item.quantity" />
            </template>
             <template
              v-slot:item.unit="{ item }">
              {{item.unit.name}}
            </template>
            <template
              v-slot:item.description="{ item }">
              <v-text-field
                type="text"
                placeholder="Descripción"
                :rules="rules.description"
                v-model="item.description"
              />
            </template>
            <template v-slot:item.action="{ item }">
              <v-tooltip left>
                <template
                  v-slot:activator="{ on }">
                  <v-btn
                    fab
                    x-small
                    color="error"
                    v-on="on"
                    @click="remove(item)">
                    <v-icon>mdi-minus</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar producto</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-form>
      </v-card>
    </v-flex>

    <v-flex
      v-else
      style="margin-top: 40px"
      class="justify-center d-flex">
      <div class="title">
        Selecciona un área para crear la orden de compra
      </div>
    </v-flex>

    <v-dialog
      @keydown.esc="addInputDialog=false"
      v-model="addInputDialog"
      max-width="450">
      <v-card>
        <v-card-title>
          Agrega el producto con merma
        </v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="products.selected"
            :search-input.sync="products.search"
            :items="products.data"
            :loading="products.loading"
            item-text="name"
            item-value="uuid"
            clearable
            hide-selected
            hide-no-data
            return-object>
            <template v-slot:item="{ item }">
              <div>
                <div>
                  {{ item.name }}
                </div>
                <div class="grey--text">
                  {{ item.display }}
                </div>
              </div>
            </template>
          </v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="primary"
            outlined
            rounded
            small
            @click="closeAddProductDialog">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            rounded
            small
            depressed
            @click="addToList">
            Agregar a la lista
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

  </div>
</template>

<script>
export default {
  data () {
    return {
      overlay: false,
      alert: false,
      addInputDialog: false,
      table: {
        headers: [
          { text: this.$t('decrease.headers.name'), value: 'name', sortable: false },
          { text: this.$t('decrease.headers.quantity'), value: 'quantity', sortable: false },
          { text: this.$t('decrease.headers.unit'), value: 'unit', sortable: false },
          { text: this.$t('decrease.headers.description'), value: 'description', sortable: false },
          { text: this.$t('decrease.headers.actions'), value: 'action', sortable: false }
        ],
        items: []
      },
      rules: {
        quantity: [v => !!v || this.$t('validations.quantity')],
        description: [v => !!v || this.$t('validations.description')]
      },
      products: {
        search: null,
        data: [],
        selected: null,
        loading: false
      },
      balance: null,
      total: 0
    }
  },
  watch: {
    'products.search': async function (product) {
      if (product && product.length >= 3) {
        this.products.loading = true
        try {
          const response = await this.$api.get('/v1/inputs', {
            skip: 0,
            name: `/${product}/i`,
            area: this.idArea
          })
          this.products.data = response.data.map(product => {
            product.display = product.choice ? `1 ${product.choice.displayUnit.name} de ${product.choice.contentQuantity} ${product.choice.contentUnit.name}` : ''
            return product
          })
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.products.loading = false
      }
    }
  },
  computed: {
    idArea: function () {
      return this.$store.state.area.id || null
    },
    restaurant () {
      return this.$store.state.currentRestaurant.data
    }
  },
  methods: {
    add () {
      this.addInputDialog = true
    },
    closeAddProductDialog () {
      this.addInputDialog = false
      this.resetProducts()
    },
    addToList () {
      const isInTable = this.table.items.some((product) => this.products.selected.id === product.id)
      if (this.products.selected && !isInTable) {
        this.table.items.push(Object.assign(
          {},
          this.products.selected,
          { quantity: null, description: '' }
        ))
      }
      this.closeAddProductDialog()
    },
    resetProducts () {
      this.products = {
        search: null,
        data: [],
        selected: null,
        loading: false
      }
    },
    remove (product) {
      const index = this.table.items.findIndex(item => item.id === product.id)
      this.table.items.splice(index, 1)
    },
    resetTable () {
      this.table.items = []
      this.$refs.decreasesForm.reset()
      this.resetProducts()
    },
    async update () {
      if (this.$refs.decreasesForm.validate()) {
        this.overlay = true
        try {
          const payload = {
            area: this.idArea,
            items: this.table.items.map(item => ({
              quantity: item.quantity,
              id: item.uuid,
              unit: item.unit.code,
              description: item.description
            })).filter(item => item.quantity > 0)
          }
          await this.$api.post('/v1/inputs/bulk/decreases', payload)
          this.$toasted.show('Las mermas se capturaron correctamente', { duration: 3000 })
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
        this.resetTable()
      }
    }
  }
}
</script>
